import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Routes from '../configuration/routes/RouteList';
import { getSupabaseAccessToken, isSupabaseAuthConfigured } from '../lib/supabaseAuth';

const AuthCallback = () => {
  const navigate = useNavigate();
  const [message, setMessage] = useState('Finishing sign-in...');

  useEffect(() => {
    let cancelled = false;

    const completeAuth = async () => {
      if (!isSupabaseAuthConfigured()) {
        navigate(Routes.Login, { replace: true });
        return;
      }

      for (let attempt = 0; attempt < 20; attempt += 1) {
        try {
          const accessToken = await getSupabaseAccessToken();
          if (accessToken) {
            if (!cancelled) {
              navigate(Routes.Home, { replace: true });
            }
            return;
          }
        } catch (error) {
          if (!cancelled) {
            setMessage((error as Error)?.message || 'Unable to complete sign-in.');
          }
          break;
        }

        await new Promise(resolve => setTimeout(resolve, 250));
      }

      if (!cancelled) {
        setMessage('Sign-in did not finish in time. Please try again.');
      }
    };

    completeAuth();

    return () => {
      cancelled = true;
    };
  }, [navigate]);

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'oklch(0.13 0.008 260)',
        color: 'oklch(0.95 0.004 260)',
        fontFamily: 'system-ui, -apple-system, sans-serif',
        padding: '24px',
      }}
    >
      <div
        style={{
          width: '100%',
          maxWidth: '360px',
          borderRadius: '16px',
          border: '1px solid oklch(1 0 0 / 0.08)',
          background: 'oklch(0.17 0.008 260)',
          padding: '28px 24px',
          textAlign: 'center',
          boxShadow: '0 32px 64px oklch(0 0 0 / 0.4)',
        }}
      >
        <div
          style={{
            display: 'inline-block',
            width: '18px',
            height: '18px',
            borderRadius: '50%',
            border: '2px solid oklch(0.52 0.22 265 / 0.28)',
            borderTopColor: 'oklch(0.72 0.18 265)',
            animation: 'spin 0.8s linear infinite',
            marginBottom: '14px',
          }}
        />
        <h1 style={{ fontSize: '18px', margin: '0 0 8px', letterSpacing: '-0.03em' }}>
          Authenticating
        </h1>
        <p style={{ margin: 0, fontSize: '13px', color: 'oklch(0.6 0.01 260)' }}>{message}</p>
      </div>
      <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
    </div>
  );
};

export default AuthCallback;
